<template>
	<vx-card :title='$t("Invoices")' v-if="invoiceData">

		<vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="invoiceData">

			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

				<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
					<div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
						<span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ invoiceData.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : invoiceData.length }} of {{ invoiceData.length }}</span>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>

					<vs-dropdown-menu>

						<vs-dropdown-item @click="itemsPerPage=10">
							<span>10</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=20">
							<span>20</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=50">
							<span>50</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=100">
							<span>100</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>

			<template slot="thead">
				<vs-th sort-key="invoice_id">{{$t("Id")}}</vs-th>
				<vs-th sort-key="finished">{{$t("DateFinished")}}</vs-th>
				<vs-th sort-key="task_num">{{$t("NumberOfTasks")}}</vs-th>
				<vs-th sort-key="first_file">{{$t("InvoiceFile")}}</vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
				<vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

					<vs-td :data="data[index].invoice_id">
						{{ data[index].invoice_id }}
					</vs-td>

					<vs-td :data="data[index].date">
						{{ moment(data[index].finished).format('DD/MM/YYYY HH:mm') }}
					</vs-td>

					<vs-td :data="data[index].task_num">
						{{ data[index].task_num }}
					</vs-td>

					<vs-td :data="data[index].invoice_file">
						{{ data[index].invoice_file }}
					</vs-td>

				</vs-tr>
				</tbody>
			</template>

		</vs-table>
	</vx-card>
</template>
<script>

	export default {
		data() {
			return {
				selected: [],
				invoices: null,
				itemsPerPage: 20,
				isMounted: false,

			}
		},
		computed: {
			currentPage() {
				if(this.isMounted) {
					return this.$refs.table.currentx
				}
				return 0
			},
			invoiceData() {
				if(this.invoices) {
					return this.invoices
				}

				return [];
			}
		},
		methods: {
			handleSelected(tr) {
				this.$router.push({ name: 'invoice', params: { id: tr.id } })
			},
			updateInvoices() {
				const thisIns = this;
				this.$http.get('/api/v1/invoice/')
						.then(function (response) {
							thisIns.invoices = response.data;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title: 'Error',
								text: error,
								color: 'danger',
								iconPack: 'feather',
								icon: 'icon-alert-circle'
							})
						});
			},
		},
		created() {
			this.updateInvoices()
		},
		mounted() {
			this.isMounted = true;
		},
	}
</script>
